import React from "react";
import { useNavigate } from "react-router-dom";
import HealthRing from "../../components/HealthRing";
import Sparkline from "../../components/Sparkline";

/**
 * Deterministic HSL from string (for logo fallback background).
 */
function hashToHSL(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
        h = (h * 31 + str.charCodeAt(i)) & 0xffffffff;
    }
    const hue = Math.abs(h) % 360;
    return `hsl(${hue}, 55%, 42%)`;
}

function initialsOf(name = "") {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0].toUpperCase())
        .join("");
}

export default function MuroCard({ item }) {
    const nav = useNavigate();
    const { company_name, has_logo, health } = item;
    const initials = initialsOf(company_name || "?");
    const bg = hashToHSL(company_name || "?");

    const open = health?.open_tickets ?? 0;
    const old = health?.open_tickets_old ?? 0;
    const color = health?.color || "green";

    let chipText;
    if (open === 0) chipText = "Tutto ok";
    else chipText = `${open} ${open === 1 ? "aperto" : "aperti"}`;

    const tooltipText =
        open === 0
            ? "0 ticket aperti"
            : old > 0
            ? `${open} ticket aperti · ${old} vecchi (>7gg, peso ×2)`
            : `${open} ticket aperti`;

    const onKey = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            nav(`/app/clienti/${item.id}`);
        }
    };

    return (
        <a
            href={`/app/clienti/${item.id}`}
            className="enl-muro-card"
            data-testid={`muro-card-${item.id}`}
            data-color={color}
            onClick={(e) => {
                e.preventDefault();
                nav(`/app/clienti/${item.id}`);
            }}
            onKeyDown={onKey}
        >
            <div
                className="enl-muro-ring-wrap"
                data-testid={`muro-ring-${item.id}`}
                tabIndex={-1}
            >
                <HealthRing color={color} size={96} stroke={5} ariaLabel={`Stato ${color}`}>
                    <div
                        className="enl-muro-logo"
                        style={
                            has_logo
                                ? { background: "#F1F5F9" }
                                : { background: bg }
                        }
                        aria-hidden
                    >
                        {has_logo && item.logo_url ? (
                            <img src={item.logo_url} alt="" />
                        ) : (
                            initials
                        )}
                    </div>
                </HealthRing>
                <div className="enl-tooltip" role="tooltip">{tooltipText}</div>
            </div>

            <div className="enl-muro-name" data-testid={`muro-name-${item.id}`}>
                {company_name || "—"}
            </div>

            <div className="enl-muro-chip" data-color={color} data-testid={`muro-chip-${item.id}`}>
                <span className="dot" />
                {chipText}
            </div>

            <Sparkline
                data={item.activity_sparkline || []}
                width={140}
                height={26}
                stroke="#94A3B8"
                fillFrom="#d9f24f"
                data-testid={`muro-spark-${item.id}`}
            />
        </a>
    );
}
